import ApplicationLogo from '@/Components/ApplicationLogo';
import FlashMessages from '@/Components/FlashMessages';
import { Link } from '@inertiajs/react';

export default function GuestLayout({ children }) {
    return (
        <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-4 py-10">
            <FlashMessages />
            {/* ambient glow */}
            <div className="pointer-events-none absolute -top-40 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-brand-500/20 blur-3xl" />
            <div className="pointer-events-none absolute bottom-0 right-0 h-80 w-80 rounded-full bg-sky-500/10 blur-3xl" />

            <div className="relative z-10 flex flex-col items-center">
                <Link href="/" className="flex flex-col items-center gap-3">
                    <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-gradient shadow-glow-lg">
                        <ApplicationLogo className="h-9 w-9 fill-current text-white" />
                    </span>
                    <span className="text-lg font-extrabold text-slate-100">آسان تتر</span>
                </Link>
            </div>

            <div className="relative z-10 mt-8 w-full overflow-hidden rounded-2xl border border-ink-600/70 bg-ink-800/70 px-6 py-8 shadow-card backdrop-blur-xl sm:max-w-md">
                {children}
            </div>

            <p className="relative z-10 mt-6 text-xs text-slate-600">
                © {new Date().getFullYear()} آسان تتر — همه حقوق محفوظ است
            </p>
        </div>
    );
}
